import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import Picture from "../../../components/Picture";

export default function Hero({ base }) {
    return (
        <section className="relative h-[70vh] min-h-[520px] w-full overflow-hidden bg-[#0B0B0C]">
            <Picture
                slug={base.cover}
                alt={`${base.name}, ${base.location}`}
                priority
                sizes="100vw"
                className="absolute inset-0 h-full w-full object-cover animate-ken-burns"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0C]/55 via-[#0B0B0C]/40 to-[#0B0B0C]" />

            <div className="relative h-full flex items-end pb-14 md:pb-20">
                <div className="shell w-full">
                    <motion.div
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 0.9,
                            ease: [0.22, 1, 0.36, 1],
                        }}
                        className="max-w-4xl"
                    >
                        <div className="flex items-center gap-4 mb-6 flex-wrap">
                            <span className="eyebrow">
                                Private · {base.year}
                            </span>
                            <span className="h-px w-10 bg-[#C9A86A]/50" />
                            <span className="text-[11px] tracking-[0.28em] uppercase text-[#9A958A]">
                                {base.location}
                            </span>
                            {base.private_only && (
                                <span className="inline-flex items-center gap-1.5 border border-[#C9A86A]/60 bg-[#0B0B0C]/60 backdrop-blur-sm text-[10px] tracking-[0.22em] uppercase text-[#C9A86A] px-3 py-1">
                                    <Lock size={10} strokeWidth={1.6} />
                                    Private Exclusive
                                </span>
                            )}
                        </div>
                        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#F3EFE7] leading-[1.04]">
                            {base.name}
                        </h1>
                        <p className="mt-6 text-lg md:text-xl text-[#C9A86A] font-serif italic max-w-3xl leading-[1.6]">
                            {base.intro}
                        </p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
